/* src/app/shared/components/embedding-report/embedding-report.component.scss */
.pBI-button {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
ion-button {
  --border-radius: 8px !important;
}
.embedding-powerBI {
  position: fixed;
  top: 140px;
  bottom: 0px;
}
.pbi-loader-text {
  position: fixed;
  margin-top: 40px;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--ion-color-primary-contrast);
  font-family: var(--ion-font-family, inherit);
  font-size: 1rem;
}
ion-modal {
  --width: 300px;
  --height: 400px;
  --border-radius: 8px;
  left: 80%;
}
ion-modal ion-datetime {
  height: 382px;
}
ion-padding {
  background-color: var(--ion-color-secondary);
}
/*# sourceMappingURL=embedding-report.component-SMSAXOWB.css.map */
